let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6QmyW")).then(() => parcelRequire('29u5J'));